import axios from 'axios'

const {
  REACT_APP_API_SCAN_V2,
  REACT_APP_API_EMPLOYEE_V2,
  REACT_APP_API_ACCIDENTS_V2,
  REACT_APP_API_APPPLICATIONS_V2
} = process.env

const headers = {
  common: {
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
}

// export const api = axios.create({
//   baseURL: `${REACT_APP_API}`,
//   headers
// })

// v2

export const scansApi = axios.create({
  baseURL: REACT_APP_API_SCAN_V2,
  headers
})

export const accidentsApi = axios.create({
  baseURL: REACT_APP_API_ACCIDENTS_V2,
  headers
})

export const employeesApi = axios.create({
  baseURL: REACT_APP_API_EMPLOYEE_V2,
  headers
})

export const applicationsApi = axios.create({
  baseURL: REACT_APP_API_APPPLICATIONS_V2,
  headers
})

export const apiByEntity = {
  scan: scansApi,
  qaCheck: scansApi,
  invoice: accidentsApi,
  accident: accidentsApi,
  employee: employeesApi,
  application: applicationsApi
}

// api.interceptors.response.use(
//   (response: AxiosResponse) => response.data,
//   (err: AxiosError) => Promise.reject(err)
// )

export function hydrateApi(accessToken?: string) {
  const bearerToken = accessToken ? `Bearer ${accessToken}` : undefined

  // api.defaults.headers.common.Authorization = bearerToken

  // v2
  scansApi.defaults.headers.common.Authorization = bearerToken
  accidentsApi.defaults.headers.common.Authorization = bearerToken
  employeesApi.defaults.headers.common.Authorization = bearerToken
  applicationsApi.defaults.headers.common.Authorization = bearerToken
}



// WEBPACK FOOTER //
// ./src/lib/api/index.ts